import React from 'react';
import { Checkbox } from 'ui';

import { getFilterId } from '../utils/get-filter-id';
import { FilterCommonProps } from './filter-common';

export const FilterCheckbox: React.FC<FilterCommonProps> = ({
  filter, updateFilter, validation
}) => {

  const checkboxId = getFilterId(filter.domain?.value, 'checkbox');

  const onChange = (value: number) => {

    const { defaultValue: defaultValueValidation, ...filteredValidation } = (validation ?? {});

    const updatedValidation = defaultValueValidation && value !== filter.defaultValue?.value
      ? filteredValidation
      : validation;

    updateFilter(
      filter.domain?.value,
      { ...filter, defaultValue: { value, description: filter.domain?.description } },
      updatedValidation
    );
  };

  return <Checkbox
    className={undefined}
    componentId={checkboxId}
    value={filter.defaultValue?.value}
    label={{ text: filter.domain?.description, visible: true }}
    validation={validation?.defaultValue}
    onChange={onChange}
  />;
};
